import BsBaseController from './_base_controller'
import Collapse from 'bootstrap/js/src/collapse'

// usage:
//   btn {
//     data-controller="bs--collapse"
//     data-bs--collapse-parent-id-value="parentId"
//     aria-controls="collapseId"
//   }
export default class extends BsBaseController {
  static values = {
    parentId: String
  }

  _setAttributes () {
    super._setAttributes("collapse")
  }

  _createBsComponent () {
    return new Collapse(this.controlsEl, {
      toggle: false,
      parent: this.hasParentIdValue && `#${this.parentIdValue}`,
    })
  }
}
